import { StatelessComponent, ReactNode } from 'react'
import * as styles from 'styles/layouts/ErrorLayout.css'
import CommonLayout from 'components/layouts/CommonLayout'
import Button from 'components/features/pfm/Button/Button'
import LoginLink from 'components/atoms/LoginLink'

export type ErrorLayoutStateProps = {
  hasLoginButton: boolean
  title: ReactNode
  subtitle: ReactNode
  text: ReactNode
  buttons: ReactNode
}

type ErrorLayoutProps = ErrorLayoutStateProps

const ErrorLayout: StatelessComponent<ErrorLayoutProps> = (props) => {
  const {
    hasLoginButton,
    title, subtitle, text,
    buttons,
  } = props

  const headerButtons: ReactNode[] | undefined = hasLoginButton
    ? [
      <div key='login' className={ styles.headerButtonWrapper }>
        <LoginLink>
          <Button size='responsive' style='hollow'>Log in</Button>
        </LoginLink>
      </div>,
    ]
    : undefined

  return (
    <CommonLayout headerButtons={ headerButtons }>
      <section className={ styles.body }>
        <h1 className={ styles.title }>
          { title }
          { subtitle }
        </h1>
        <div className={ styles.circles }>
          <div className={ styles.memberCircle } />
          <div className={ styles.peersCircle } />
          <div className={ styles.othersCircle } />
        </div>
        <article className={ styles.text }>
          { text }
        </article>
        <footer className={ styles.buttons }>
          { buttons }
        </footer>
      </section>
    </CommonLayout>
  )
}

export const ButtonWrapper: StatelessComponent = ({ children }) => (
  <div className={ styles.buttonWrapper }>
    { children }
  </div>
)

export const SuperTitle: StatelessComponent = ({ children }) => (
  <div className={ styles.superTitle }>
    { children }
  </div>
)

export default ErrorLayout
